import {PredicateModel} from '@app/core/model/filtering/predicate-model';

export enum FilterPredicate {
    AFTER = 'After',
    ARRAY_ANY_EQUAL = 'ArrayAnyEqual',
    ARRAY_ANY_CONTAINS = 'ArrayAnyContains',
    BEFORE = 'Before',
    CONTAINS = 'Contains',
    CONTAINS_ANY_OF = 'ContainsAnyOf',
    NOT_CONTAINS_ANY_OF = 'NotContainsAnyOf',
    DATE_BETWEEN = 'DateBetween',
    DOES_NOT_CONTAIN = 'DoesNotContain',
    ENDS_WITH = 'EndsWith',
    EQUAL = 'Equal',
    EQUAL_DATE = 'EqualDate',
    IS_EMPTY = 'IsEmpty',
    IS_FALSE = 'IsFalse',
    IS_FUTURE = 'IsFuture',
    IS_NOT_CONTAIN_ANY_OF = 'IsNotContainAnyOf',
    IS_NOT_EMPTY = 'IsNotEmpty',
    IS_NOT_NULL = 'IsNotNull',
    IS_NOT_VALID_EMAIL = 'IsNotValidEmail',
    IS_NULL = 'IsNull',
    IS_PAST = 'IsPast',
    IS_TRUE = 'IsTrue',
    IS_VALID_EMAIL = 'IsValidEmail',
    NOT_EQUAL = 'NotEqual',
    REGEXP = 'Regexp',
    STARTS_WITH = 'StartsWith',
    IS_STUDENTS_EXIST = 'IsStudentsExist',
    IS_STUDENTS_NOT_EXIST = 'IsStudentsNotExist',
    IS_ROSTERS_EMPTY = 'IsRostersEmpty'
}

export const DefaultDataBrowsingFilterPredicates: PredicateModel[] = [
    new PredicateModel(FilterPredicate.IS_EMPTY, false, false),
    new PredicateModel(FilterPredicate.IS_NOT_EMPTY, false, false)
];

export enum AttributeType {
    ADDRESS_TYPE = 'AddressType',
    BOOLEAN = 'Boolean',
    CONTACT_RELATIONSHIP_LIST = 'ContactRelationship[]',
    DEMOGRAPHIC_GENDER = 'DemographicGender',
    DEMOGRAPHIC_RACE = 'DemographicRace',
    DEMOGRAPHIC_SCHOOL_RESIDENCE_STATUS = 'DemographicSchoolResidenceStatus',
    EMAIL = 'Email',
    EMAIL_TYPE = 'EmailType',
    GRADE = 'Grade',
    GRADE_LIST = 'Grade[]',
    GROUP_MEMBERSHIP = 'GroupMembership[]',
    GUID = 'Guid',
    LOCAL_DATE = 'LocalDate',
    INSTANT = 'INSTANT',
    NAME_TYPE = 'NameType',
    PERSON_TYPE = 'PersonType',
    PERSON_STATUS = 'PersonStatus',
    PHONE_NUMBER_TYPE = 'PhoneNumberType',
    RACE = 'Race',
    STRING = 'String',
    STRING_LIST = 'String[]',
    SYSTEM_ID = 'SystemId[]',
    TEACHER_ROSTER_REFERENCE_LIST = 'TeacherRosterReference[]',
    USER_REFERENCE = 'UserReference[]',
    ENTITY_STATUS = 'EntityStatus',
}

// Filter Rules
export const FilterDefaultPredicateMap = new Map<AttributeType, FilterPredicate>([
    [AttributeType.ADDRESS_TYPE, FilterPredicate.EQUAL],
    [AttributeType.BOOLEAN, FilterPredicate.IS_TRUE],
    [AttributeType.CONTACT_RELATIONSHIP_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.DEMOGRAPHIC_GENDER, FilterPredicate.EQUAL],
    [AttributeType.DEMOGRAPHIC_RACE, FilterPredicate.EQUAL],
    [AttributeType.DEMOGRAPHIC_SCHOOL_RESIDENCE_STATUS, FilterPredicate.EQUAL],
    [AttributeType.EMAIL, FilterPredicate.CONTAINS],
    [AttributeType.EMAIL_TYPE, FilterPredicate.EQUAL],
    [AttributeType.GRADE, FilterPredicate.EQUAL],
    [AttributeType.GRADE_LIST, FilterPredicate.EQUAL],
    [AttributeType.GROUP_MEMBERSHIP, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.GUID, FilterPredicate.EQUAL],
    [AttributeType.LOCAL_DATE, FilterPredicate.DATE_BETWEEN],
    [AttributeType.INSTANT, FilterPredicate.DATE_BETWEEN],
    [AttributeType.NAME_TYPE, FilterPredicate.EQUAL],
    [AttributeType.PERSON_TYPE, FilterPredicate.EQUAL],
    [AttributeType.PERSON_STATUS, FilterPredicate.EQUAL],
    [AttributeType.PHONE_NUMBER_TYPE, FilterPredicate.EQUAL],
    [AttributeType.RACE, FilterPredicate.EQUAL],
    [AttributeType.STRING, FilterPredicate.CONTAINS],
    [AttributeType.STRING_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.SYSTEM_ID, FilterPredicate.CONTAINS],
    [AttributeType.TEACHER_ROSTER_REFERENCE_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.USER_REFERENCE, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.ENTITY_STATUS, FilterPredicate.EQUAL]
]);

export enum DataBrowsingFilterPredicate {
    EQUALS = '=',
    NOT_EQUAL = '!=',
    IN_ARRAY = '@>',
    NOT_IN_ARRAY = '!@>',
    IS_EMPTY_ARRAY = '@<>',
    IS_NOT_EMPTY_ARRAY = '!@<>',
    GREATER_THEN = '>',
    GREATER_THEN_OR_EQUAL = '>=',
    LESSER_THEN = '<',
    LESSER_THEN_OR_EQUAL = '<=',
    // CONTAINS = '~',
    // NOT_CONTAINS = '~!'
    CONTAINS = '^',
    NOT_CONTAINS = '!^'
}

export enum DataBrowsingFilterPredicateFriendlyName {
    After = 'after',
    ArrayAnyContains = 'contains text',
    Before = 'before',
    Contains = 'contains text',
    DoesNotContain = 'does not contain text',
    EqualDate = 'equals',
    IsEmpty = 'is empty',
    IsFalse = 'is false',
    IsFuture = 'is future',
    IsNotContainAnyOf = 'does not contain text',
    IsNotEmpty = 'is not empty',
    IsPast = 'is past',
    IsTrue = 'is true'
}

export const DataBrowsingFilterPredicateMap = new Map<FilterPredicate, DataBrowsingFilterPredicate>([
    [FilterPredicate.AFTER, DataBrowsingFilterPredicate.GREATER_THEN],
    [FilterPredicate.ARRAY_ANY_EQUAL, DataBrowsingFilterPredicate.CONTAINS],
    [FilterPredicate.ARRAY_ANY_CONTAINS, DataBrowsingFilterPredicate.CONTAINS],
    [FilterPredicate.BEFORE, DataBrowsingFilterPredicate.LESSER_THEN],
    [FilterPredicate.CONTAINS, DataBrowsingFilterPredicate.CONTAINS],
    [FilterPredicate.DOES_NOT_CONTAIN, DataBrowsingFilterPredicate.NOT_CONTAINS],
    [FilterPredicate.EQUAL, DataBrowsingFilterPredicate.EQUALS],
    [FilterPredicate.EQUAL_DATE, DataBrowsingFilterPredicate.EQUALS],
    [FilterPredicate.IS_EMPTY, DataBrowsingFilterPredicate.EQUALS],
    [FilterPredicate.IS_FALSE, DataBrowsingFilterPredicate.EQUALS],
    [FilterPredicate.IS_FUTURE, DataBrowsingFilterPredicate.GREATER_THEN],
    [FilterPredicate.IS_NOT_CONTAIN_ANY_OF, DataBrowsingFilterPredicate.NOT_CONTAINS],
    [FilterPredicate.IS_NOT_EMPTY, DataBrowsingFilterPredicate.NOT_EQUAL],
    [FilterPredicate.IS_PAST, DataBrowsingFilterPredicate.LESSER_THEN],
    [FilterPredicate.IS_TRUE, DataBrowsingFilterPredicate.EQUALS],
    [FilterPredicate.NOT_EQUAL, DataBrowsingFilterPredicate.NOT_EQUAL]
]);

// Data browsing
export const DataBrowsingFilterDefaultPredicateMap = new Map<AttributeType, FilterPredicate>([
    [AttributeType.ADDRESS_TYPE, FilterPredicate.CONTAINS],
    [AttributeType.BOOLEAN, FilterPredicate.IS_TRUE],
    [AttributeType.CONTACT_RELATIONSHIP_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.DEMOGRAPHIC_GENDER, FilterPredicate.CONTAINS],
    [AttributeType.DEMOGRAPHIC_RACE, FilterPredicate.CONTAINS],
    [AttributeType.DEMOGRAPHIC_SCHOOL_RESIDENCE_STATUS, FilterPredicate.CONTAINS],
    [AttributeType.EMAIL, FilterPredicate.CONTAINS],
    [AttributeType.EMAIL_TYPE, FilterPredicate.CONTAINS],
    [AttributeType.GRADE, FilterPredicate.CONTAINS],
    [AttributeType.GRADE_LIST, FilterPredicate.CONTAINS],
    [AttributeType.GROUP_MEMBERSHIP, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.GUID, FilterPredicate.CONTAINS],
    [AttributeType.LOCAL_DATE, FilterPredicate.EQUAL_DATE],
    [AttributeType.INSTANT, FilterPredicate.EQUAL_DATE],
    [AttributeType.NAME_TYPE, FilterPredicate.CONTAINS],
    [AttributeType.PERSON_TYPE, FilterPredicate.CONTAINS],
    [AttributeType.PERSON_STATUS, FilterPredicate.CONTAINS],
    [AttributeType.PHONE_NUMBER_TYPE, FilterPredicate.CONTAINS],
    [AttributeType.RACE, FilterPredicate.CONTAINS],
    [AttributeType.STRING, FilterPredicate.CONTAINS],
    [AttributeType.STRING_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.SYSTEM_ID, FilterPredicate.CONTAINS],
    [AttributeType.TEACHER_ROSTER_REFERENCE_LIST, FilterPredicate.ARRAY_ANY_CONTAINS],
    [AttributeType.USER_REFERENCE, FilterPredicate.ARRAY_ANY_CONTAINS]
]);

export enum FilterPredicateFriendlyName {
    After = 'after',
    ArrayAnyEqual = 'equals any of',
    ArrayAnyContains = 'any contains text',
    Before = 'before',
    Contains = 'contains text',
    ContainsAnyOf = 'contains any of',
    NotContainsAnyOf = 'does not contains any of',
    DateBetween = 'date between',
    DoesNotContain = 'does not contain text',
    EndsWith = 'ends with',
    Equal = 'equals',
    EqualDate = 'equals',
    IsEmpty = 'is empty',
    IsFalse = 'is false',
    IsFuture = 'is future',
    IsNotContainAnyOf = 'does not contain text',
    IsNotEmpty = 'is not empty',
    IsNotNull = 'is not empty',
    IsNull = 'is empty',
    IsPast = 'is past',
    IsTrue = 'is true',
    IsValidEmail = 'is valid email',
    NotEqual = 'does not equal',
    Regexp = 'regexp',
    StartsWith = 'starts with',
    IsStudentsExist = 'students exist',
    IsRostersEmpty = 'is empty'
}

export const DENIED_PREDICATES_LIST = new Map<AttributeType, FilterPredicate>([
    [AttributeType.USER_REFERENCE, FilterPredicate.ARRAY_ANY_CONTAINS]
]);
